export default "__VITE_ASSET__DmlLoiJS__"